import { resolve } from 'rsvp';
import $ from 'jquery';
import Mixin from '@ember/object/mixin';
const INTERCOM_EMBED_JS_URL = '//static.intercomassets.com/ember/intercom-embed.js.gz';
export default Mixin.create({
  _getScript(url) {
    // Exposed for testing
    return $.getScript(url);
  },
  loadIntercomEmbedJs() {
    if (typeof window.IntercomEmbed !== 'undefined') {
      return resolve();
    }
    return this._getScript(INTERCOM_EMBED_JS_URL);
  }
});